import React from 'react';

import UserDefault from '~/components/UserDefault';
import { Container } from './styles';

const Header: React.FC = () => (
  <Container>
    <div className="container mt-5 mt-lg-0">
      <UserDefault amortizacion />
    </div>
  </Container>
);

export default Header;
